<template>
  <svg
    id="apple-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21.284"
    height="26.143"
    :fill="color"
    viewBox="0 0 21.284 26.143"
  >
    <path
      d="M18.343 6.17A5.722 5.722 0 0 0 19.729 2a5.806 5.806 0 0 0-3.921 1.987A5.452 5.452 0 0 0 14.5 8.026a4.821 4.821 0 0 0 3.843-1.856zm3.294 9.725a5.9 5.9 0 0 1 2.823-4.98A6.09 6.09 0 0 0 19.677 8.3c-2.039-.209-3.921 1.189-5.006 1.189s-2.614-1.163-4.313-1.137a6.431 6.431 0 0 0-5.411 3.307c-2.3 4-.588 9.947 1.712 13.175 1.046 1.582 2.353 3.372 4.078 3.307s2.287-1.072 4.287-1.072 2.614 1.072 4.313 1.033 2.9-1.621 4-3.2a14.356 14.356 0 0 0 1.8-3.725 5.765 5.765 0 0 1-3.5-5.283z"
      transform="translate(-3.856 -2)"
    />
  </svg>
</template>

<script>
import IconMixin from '@/mixins/icon-mixin'

export default {
  name: 'AppleIcon',
  mixins: [IconMixin],
  computed: {
    color() {
      return this.isDark ? '#808080' : '#000000'
    },
  },
}
</script>
